import React from 'react';
import { nextSort } from 'Utils/SortableTh';

/**
 * Click-to-sort header cell for the div-grid ledgers (the shared SortableTh is a <th>, which
 * cannot live in a CSS-grid row). Same cycle as the other ledgers: ascending → descending →
 * back to the default order. Shared by the area overview and the findings list.
 */
const SortHeader = ({ label, sortKey, sort, onSort, title }) => {
  const active = !!(sort && sort.key === sortKey);
  return (
    <div role='columnheader' aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
      <button
        type='button'
        className={`edl-sort${active ? ' edl-sort--on' : ''}`}
        title={title || `Sort by ${label.toLowerCase()}`}
        onClick={() => onSort(nextSort(sort, sortKey))}
        data-testid={`edl-sort-${sortKey}`}
      >
        {label}{active ? (sort.dir === 'asc' ? ' ▲' : ' ▼') : ''}
      </button>
    </div>
  );
};

export default SortHeader;
